// extracted by mini-css-extract-plugin
module.exports = {"Language":"Languages_Language__I8T32","MobileView":"Languages_MobileView__2DIdt"};